import {useEffect, useState} from 'react'
import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import LogoMc from '../../../_metronic/assets/mc-logo.svg'
import BG_CONTAINER from '../asset/circle-container.jpg'
import MAIN from '../asset/main.jpg'
import MAIN_2 from '../asset/main-2.jpeg'
import {LanguageList} from '../helper/languageList'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import {Field, Formik, Form} from 'formik'
import {useCreatePassword} from '../context/useMutation'
import PasswordChecklist from 'react-password-checklist'
import {API} from 'src/feature/bite/domain'
import useRequestParams from 'src/feature/bite/hook/request'

export default function CreatePassword() {
  const intl = useIntl()
  const {headers} = useRequestParams()

  const [tokenStatus, setTokenStatus] = useState('loading')
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')
  const [passwordShown, setPasswordShown] = useState(false)
  const [passwordConfirmShown, setPasswordConfirmShown] = useState(false)
  const [passwordValid, setPasswordValid] = useState(false)

  const {mutateAsync, isLoading} = useCreatePassword()

  const urlQuery = new URLSearchParams(window.location.search)
  const token = urlQuery.get('token')
  const userID = urlQuery.get('RequestedId')

  useEffect(() => {
    const verifyToken = async () => {
      const Response = await fetch(`${API}/Merchant/Activate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
        body: JSON.stringify({
          language: headers.Language,
          code: token?.replace('{', '').replace('}', ''),
          RequestId: userID?.replace('{', '').replace('}', ''),
        }),
      })

      const data = await Response.json()
      if (data?.responseResult?.result) setTokenStatus('success')
      else if (
        !data?.responseResult?.result &&
        data?.responseResult?.exceptionDetail === 'Expired' //ToDo: Servis güncellenince değişecek
      )
        setTokenStatus('expired')
      else setTokenStatus('failed')
    }
    verifyToken()
  }, [token, userID])

  const resendToken = async () => {
    if (tokenStatus === 'expired') {
      try {
        const Response = await fetch(`${API}/Merchant/ResendMail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json-patch+json',
          },
          body: JSON.stringify({
            language: headers.Language,
            code: token?.replace('{', '').replace('}', ''),
            requestId: userID?.replace('{', '').replace('}', ''),
            email,
          }),
        })

        const data = (await Response?.json()) ?? {}

        if (!data?.responseResult?.result) {
          // return setError('An error occured, please try again later')
          return setError(intl.formatMessage({id: 'ERROR'}))
        }

        setTokenStatus('newTokenSent')
      } catch (e) {
        // setError('An error occured, please try again later')
        setError(intl.formatMessage({id: 'ERROR'}))
      }
    }
  }

  const handleSubmit = async (values) => {
    const pendinguserID = userID?.replace('{', '').replace('}', '')
    const code = token?.replace('{', '').replace('}', '')

    if (!pendinguserID || !code) return setError(intl.formatMessage({id: 'ERROR'}))
    if (!passwordValid) return

    await mutateAsync({values, code, pendinguserID})
  }

  const validationSchema = Yup.object({
    password: Yup.string().required(' ').min(6, ' ').max(50, ' '),
    confirmPassword: Yup.string()
      .required(' ')
      .oneOf([Yup.ref('password'), ''], ' '),
  })

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
        <a href='sign-in' className='d-block d-lg-none mx-auto pt-10'>
          <img alt='Logo' src={Logo} className='h-25px' />
        </a>

        <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10'>
          <div className='d-flex justify-content-between flex-column-fluid flex-column w-100 mw-550px gap-10'>
            <div className='d-flex flex-stack py-2'>
              <div className='m-0'>
                <div className='d-none d-md-block'>
                  <img alt='Logo' src={LogoMc} className='h-25px' />
                  <img alt='Logo' src={Logo} className='h-35px' />
                </div>
              </div>
            </div>

            <div>
              {tokenStatus === 'loading' && (
                <div className='py-20 mt-20'>
                  <div className='spinner spinner-primary spinner-center h-50px w-50px'></div>

                  <div className='text-center text-gray-600 fw-bold pt-15'>
                    {intl.formatMessage({id: 'LOADING'})}
                  </div>
                </div>
              )}

              {tokenStatus === 'success' && (
                <div className='py-20 mt-20 w-100'>
                  <div className='text-start mb-10'>
                    <h1
                      className='text-primary mb-3 fs-3x'
                      data-kt-translate='password-reset-title'
                    >
                      {intl.formatMessage({id: 'FORGOT.PASSWORD_CREATE'})}
                    </h1>

                    <div
                      className='text-gray-400 fw-semibold fs-6'
                      data-kt-translate='password-reset-desc'
                    >
                      {intl.formatMessage({id: 'FORGOT.PASSWORD_DESC'})}
                    </div>
                  </div>

                  <Formik
                    className='form w-100'
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    initialValues={{
                      password: '',
                      confirmPassword: '',
                    }}
                  >
                    {({errors, touched, values}) => (
                      <Form>
                        <div className='fv-row mb-7 form-floating'>
                          {/* eye icon */}
                          <div
                            className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                            style={{cursor: 'pointer'}}
                            onClick={() => setPasswordShown(!passwordShown)}
                          >
                            <i
                              className={`bi ${passwordShown ? 'bi-eye-slash' : 'bi-eye'}`}
                              style={{fontSize: '1.4rem'}}
                            ></i>
                          </div>
                          <Field
                            name='password'
                            type={passwordShown ? 'text' : 'password'}
                            className='form-control'
                            placeholder=''
                          />
                          <label>
                            {/* Password */}
                            {intl.formatMessage({id: 'FORGOT.PASSWORD'})}
                          </label>
                          {errors.password && touched.password ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.password}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className='fv-row mb-4 form-floating'>
                          <div
                            className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                            style={{cursor: 'pointer'}}
                            onClick={() => setPasswordConfirmShown(!passwordConfirmShown)}
                          >
                            <i
                              className={`bi ${passwordConfirmShown ? 'bi-eye-slash' : 'bi-eye'}`}
                              style={{fontSize: '1.4rem'}}
                            ></i>
                          </div>
                          <Field
                            name='confirmPassword'
                            type={passwordConfirmShown ? 'text' : 'password'}
                            className='form-control'
                            placeholder=''
                          />
                          <label>
                            {/* Re-Password */}
                            {intl.formatMessage({id: 'FORGOT.CONFIRM_PASSWORD'})}
                          </label>
                          {errors.confirmPassword && touched.confirmPassword ? (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.confirmPassword}</div>
                            </div>
                          ) : null}
                        </div>
                        <div>
                          <PasswordChecklist
                            className='mb-7'
                            rules={[
                              'minLength',
                              'specialChar',
                              'number',
                              'capital',
                              'lowercase',
                              'match',
                            ]}
                            minLength={6}
                            value={values.password}
                            valueAgain={values.confirmPassword}
                            onChange={(isValid) => {
                              setPasswordValid(isValid)
                            }}
                            messages={{
                              minLength: intl.formatMessage({
                                id: 'FORGOT.PASSWORD.RULES.MIN_LENGTH',
                              }),
                              specialChar: 'At least one special character (e.g. !@#$%^&*)',
                              number: 'At least one number (e.g. 0-9)',
                              capital: 'At least one capital letter (e.g. A-Z)',
                              lowercase: 'At least one lowercase letter (e.g. a-z)',
                              match: 'Passwords must match',
                            }}
                          />
                        </div>

                        {error && (
                          <div className='fv-row mb-10 form-floating'>
                            <p className='text-danger'>{error}</p>
                          </div>
                        )}

                        <div className='d-flex flex-stack'>
                          <div className='m-0'>
                            <button disabled={isLoading} className='btn btn-primary me-2'>
                              {isLoading ? (
                                <span data-kt-translate='general-progress'>
                                  {intl.formatMessage({id: 'LOADING'})}
                                </span>
                              ) : (
                                <>
                                  <i className='bi bi-arrow-right me-3 fs-3'></i>
                                  {intl.formatMessage({id: 'GLOBAL.BUTTON.SUBMIT'})}
                                </>
                              )}
                            </button>

                            <a href='sign-in' className='btn fw-bold'>
                              {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
                            </a>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              )}

              {tokenStatus === 'expired' && (
                <div className='py-20 mt-20 w-100'>
                  <div className='text-start mb-10'>
                    <h1
                      className='text-primary mb-3 fs-3x'
                      data-kt-translate='password-reset-title'
                    >
                      {intl.formatMessage({id: 'FORGOT.REQUEST_NEW_URL'})}
                    </h1>

                    <div
                      className='text-gray-400 fw-semibold fs-6'
                      data-kt-translate='password-reset-desc'
                    >
                      <p className=''>{intl.formatMessage({id: 'FORGOT.PASSWORD_EXPIRED'})}</p>
                    </div>
                  </div>

                  <div className='fv-row mb-10 form-floating'>
                    <input
                      type='text'
                      className='form-control'
                      value={email}
                      onChange={(e) => {
                        const value = e.target.value.toLowerCase()
                        const noTurkishChars = value.replaceAll(/[ğĞüÜşŞıİöÖçÇ]/g, '')
                        setEmail(noTurkishChars)
                      }}
                      id='floatingInput'
                      style={{borderColor: error ? 'red' : ''}}
                      placeholder='name@example.com'
                    />
                    <label>E-mail</label>{' '}
                    {error && (
                      <div className='fv-row mb-10 form-floating'>
                        <p className='text-danger'>{error}</p>
                      </div>
                    )}
                  </div>

                  <div className='d-flex flex-stack'>
                    <div className='m-0'>
                      <button className='btn btn-primary me-2' onClick={() => resendToken()}>
                        <i className='bi bi-arrow-right me-3 fs-3'></i>
                        <span className='indicator-label'>
                          {intl.formatMessage({id: 'GLOBAL.BUTTON.SUBMIT'})}
                        </span>

                        <span className='indicator-progress'>
                          {/* Please wait... */}
                          {intl.formatMessage({id: 'LOADING'})}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      </button>
                      <a
                        href='sign-in'
                        className='btn fw-bold'
                        data-kt-translate='password-reset-cancel'
                      >
                        {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
                      </a>
                    </div>
                  </div>
                </div>
              )}

              {tokenStatus === 'failed' && (
                <div className='py-20 mt-20'>
                  <div className='form w-100' id='kt_password_reset_form'>
                    <div className='text-start mb-10'>
                      <p className='fw-semibold fs-6 text-danger'>
                        {/* Your password creation URL is invalid. */}
                        {intl.formatMessage({id: 'FORGOT.PASSWORD_INVALID'})}
                      </p>
                    </div>

                    <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-10'>
                      <div>
                        <a
                          href='sign-in'
                          id='kt_password_reset_submit'
                          className='btn btn-primary me-2'
                          data-kt-translate='password-reset-submit'
                        >
                          <i className='bi bi-arrow-right me-3 fs-3'></i>
                          <span className='indicator-label'>
                            {intl.formatMessage({id: 'GLOBAL.BUTTON.LOGIN'})}
                          </span>

                          <span className='indicator-progress'>
                            {intl.formatMessage({id: 'LOADING'})}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        </a>
                      </div>
                      <div style={{paddingRight: 45}}>
                        <a href='forgot-password' data-kt-translate='sign-in-forgot-password'>
                          {intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {tokenStatus === 'newTokenSent' && (
                <div className='py-20 mt-20'>
                  <div className='form w-100' id='kt_password_reset_form'>
                    <div className='text-start mb-10'>
                      <p className='fw-semibold fs-6 text-danger'>
                        {/* Your password creation URL is invalid. */}
                        {intl.formatMessage({id: 'FORGOT.PASSWORD_INVALID'})}
                      </p>
                    </div>

                    <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-10'>
                      <div>
                        <a
                          href='sign-in'
                          id='kt_password_reset_submit'
                          className='btn btn-primary me-2'
                          data-kt-translate='password-reset-submit'
                        >
                          <i className='bi bi-arrow-right me-3 fs-3'></i>
                          <span className='indicator-label'>
                            {intl.formatMessage({id: 'GLOBAL.BUTTON.LOGIN'})}
                          </span>

                          <span className='indicator-progress'>
                            {intl.formatMessage({id: 'LOADING'})}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        </a>
                      </div>
                      <div style={{paddingRight: 45}}>
                        <a href='forgot-password' data-kt-translate='sign-in-forgot-password'>
                          {intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className='mt-2'>
                <LanguageList />
              </div>
            </div>
            <div></div>
          </div>
        </div>

        <div
          className='d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-center bgi-no-repeat'
          style={{
            backgroundImage: `url('${BG_CONTAINER}')`,
          }}
        >
          <div className='d-flex flex-column flex-center p-15 w-100 position-relative'>
            <div
              className='rounded-circle shadow-lg d-flex flex-center position-absolute'
              style={{
                width: '380px',
                height: '380px',
                top: '12%',
                left: '12%',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(15px)',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                zIndex: 2,
              }}
            >
              <img
                src={MAIN}
                alt='Mastercard Solutions'
                className='w-100 h-100'
                style={{objectFit: 'cover'}}
              />
            </div>

            <div
              className='rounded-circle shadow-lg d-flex flex-center position-absolute'
              style={{
                width: '300px',
                height: '300px',
                bottom: '12%',
                right: '12%',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(15px)',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                zIndex: 1,
              }}
            >
              <img
                src={MAIN_2}
                alt='Mastercard Solutions 2'
                className='w-100 h-100'
                style={{objectFit: 'cover'}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
